import { AtlasGqlCollaboratorsFragmentFragment } from 'types/atlas-graphql';

export const formatCollaborator = (collaborator: AtlasGqlCollaboratorsFragmentFragment) => {
  const { firstName, lastName, email, defaultOrganization } = collaborator;
  // We at least need email or defaultOrganization to show a user
  if (!email && !defaultOrganization?.name) {
    return '(Invalid User)';
  }

  const userName = firstName && lastName ? `${firstName} ${lastName} (${email})` : `${email}`;
  const orgName = defaultOrganization?.name ? ` | ${defaultOrganization.name}` : '';

  return `${userName}${orgName}`;
};
